// src/utils/versionApp.js
// Detección de versión nueva de la app (deploy de hosting).
// El build escribe /version.json (scripts/generar-version.js); acá se consulta
// con no-store (~50 bytes, costo Q0) para comparar contra la versión con la que
// cargó esta pestaña. En desarrollo (npm start) el archivo no existe → devuelve
// null y todo queda silencioso.

export const INTERVALO_CHEQUEO_MS = 10 * 60 * 1000; // 10 minutos

export async function obtenerVersionRemota() {
  try {
    const res = await fetch('/version.json', { cache: 'no-store' });
    if (!res.ok) return null;
    const data = await res.json();
    return typeof data.version === 'string' && data.version ? data.version : null;
  } catch (e) {
    return null; // sin red / dev / archivo ausente: no es error, simplemente no hay dato
  }
}
